module.exports = __webpack_public_path__ + "img/7.8.TSS.8fe4615f.png";